import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const ReloadIcon = (properties: iconType) => (
  <>
    <SvgIcon
      {...properties}
      viewBox="0 0 18 18"
      style={{ fill: 'none', width: '18px', height: '18px' }}
    >
      <path d="M6.45651 3H8.00987C11.8708 3 15 6.16569 15 10.0189C15 13.6102 12.2801 16.5689 8.78267 16.9526C6.06814 17.3402 0.631383 15.4023 1.01975 9.20116" />
      <path d="M9 1L6 3L9 5" />
    </SvgIcon>
  </>
);

ReloadIcon.defaultProperties = {
  strokeMiterlimit: '10',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  stroke: '#78869E',
};

export default ReloadIcon;
